import axios from "axios"
export const API_URL = process.env.REACT_APP_CORE_API;


const emitNetworkActivity = (type, detail = {}) => {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(type, { detail }));
  }
};

const appHeaderProperties = {
  Accept: 'application/json',
}

const friendlyTechnicalMessage = (value) => {
  if (typeof value !== 'string') return value;
  const raw = value.trim();
  if (!raw) return value;

  // Never expose implementation terms or raw infrastructure/database errors in UI messages.
  const technical = /(backend|back-end|\bapi\b|endpoint|database|server|controller|repository|gorm|postgres|sqlstate|sql syntax|relation .* does not exist|duplicate key|foreign key|panic|stack trace|connection refused|dial tcp|no such host)/i;
  if (technical.test(raw)) {
    return 'Terjadi kendala saat memproses permintaan. Silakan coba lagi atau hubungi administrator jika masalah berlanjut.';
  }

  return raw
    .replace(/\s*\(\s*ID\s*:\s*\d+\s*\)/gi, '')
    .replace(/\bID\s*:\s*\d+\b/gi, '')
    .replace(/\bID\s+\d+\b/gi, '')
    .replace(/\s{2,}/g, ' ')
    .trim();
};

const sanitizeResponse = (payload) => {
  if (!payload || typeof payload !== 'object') return payload;
  if (Array.isArray(payload)) return payload.map(sanitizeResponse);
  const next = { ...payload };
  ['message', 'msg', 'error_message', 'description'].forEach((key) => {
    if (typeof next[key] === 'string') next[key] = friendlyTechnicalMessage(next[key]);
  });
  return next;
};

export const apiCall = async ({ method, url, data = "", baseURL }, navigation) => {
  let head = {
    ...appHeaderProperties,
    ...data.headers,
  };
  emitNetworkActivity('bolde-request-start', { method, url });
  try {
    const response = await axios({
      baseURL: baseURL || API_URL,
      method: method,
      url: url,
      data: data.data || "",
      headers: head || "",
      params: data.params || "",
      'axios-retry': {
        retries: 0
      }
    });
    return sanitizeResponse(response.data);
  } catch (error) {
    console.error(error);
    const payload = error?.response?.data || {
      status: 'error',
      message: 'Terjadi kendala saat memproses permintaan. Silakan coba lagi.'
    };
    return sanitizeResponse(payload);
  } finally {
    emitNetworkActivity('bolde-request-end', { method, url });
  }
};
